0<template>
    <main style="margin-top: 25px;">

        <loading />
        <notifications />

        <section>

            <!--inicio inserir cpf-->
            <div class="content-960" v-if="step == 0">
                <div class="wrapper-960 clearfix">
                    <div class="titles">
                        <h2 class="uppercase"><b><i class="fa fa-pencil"></i> Realizar teste</b></h2>
                    </div>

                    <div class="mold-txt-center">
                        <form ref="testerealizar-form-cpf" v-on:submit.prevent="buscarCandidato(cpf)">
                            <div class="row">
                                <div class="form-group col-md-12">
                                    <label for="nome">Digite seu CPF</label>
                                    <input type="text" class="form-control" name="nome" placeholder="___.___.___-__" v-model="cpf" v-mask="mask_cpf" required />
                                </div>
                            </div>
                            <button type="button" class="btn-large-40 btn-red uppercase" @click="buscarCandidato(cpf)">
                                <i class="fa fa-arrow-right"></i>
                                Acessar teste
                            </button>
                        </form>
                    </div>
                </div>
            </div>

            <!--mensagem inicial bem vindo teste-->
            <div class="content-960" v-if="step == 1">
                <div class="wrapper-960 clearfix">

                    <div class="card">

                        <div class="card-body">
                            <div class="podeConterIMG" v-html="teste.avaliacao.mensagemInicial"></div>
                        </div>

                        <div class="card-footer">
                            <ul class="pagination">
                                <li class="page-item"><a class="page-link" @click="iniciarTeste()">Iniciar teste</a></li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>

            <!--questoes e perguntas-->
            <div class="content-960" v-if="step == 2">
                <div class="wrapper-960 clearfix">

                    <!--tempo no header-->
                    <div class="row">
                        <div class="col-md-6 text-left">                            
                            <h4>
                                <strong>{{substep+1}}/{{totalQuestoes}}</strong>
                            </h4>                            
                        </div>
                        <div class="col-md-6 text-right" v-bind:class="{ 'text-danger': temporestante <= 10 }">
                            <small v-if="temporestante <= 10">Seu tempo está quase acabando</small>
                            Tempo restante: <strong>{{ temporestante }} min.</strong><br />
                        </div>
                    </div>

                    <!--barra de progresso de realização-->
                    <div class="row">
                        <div class="col-md-12">
                            <b-progress :value="progresso" variant="success" striped :animated="true" class="mb-2"></b-progress>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-body" v-for="(testeQuestaoPergunta, index) in teste.collectionTesteQuestaoPergunta" v-bind:key="testeQuestaoPergunta.questaoPerguntaId" v-if="substep == index">

                            <strong>Questão {{index + 1}} - {{testeQuestaoPergunta.questaoPergunta.questao.disciplina.nome}}</strong>
                            <hr />

                            <small>Enunciado</small>
                            <div class="podeConterIMG" v-html="testeQuestaoPergunta.questaoPergunta.questao.enunciado" />
                            <hr />

                            <small>Pergunta</small>
                            <div class="podeConterIMG" v-html="testeQuestaoPergunta.questaoPergunta.pergunta"></div>

                            <!--pergunta do tipo alternativa 1 correta -->
                            <div v-if="testeQuestaoPergunta.questaoPergunta.questao.tipoRespostaId == 1 && !testeQuestaoPergunta.questaoPergunta.multiplasCorretas">
                                <br />
                                <ul class="list-group">
                                    <li class="list-group-item" v-for="questaoResposta in testeQuestaoPergunta.questaoPergunta.collectionQuestaoPerguntaResposta" v-bind:key="questaoResposta.questaoId">
                                        <label class="custom-control custom-radio">
                                            <input type="radio" name="questaoResposta.resposta" v-model="testeQuestaoPergunta.resposta" :value="questaoResposta.resposta" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description podeConterIMG" v-html="questaoResposta.resposta"></span>
                                        </label>
                                    </li>
                                </ul>
                            </div>

                            <!--pergunta do tipo alternativa mais de 1 correta -->
                            <div v-if="testeQuestaoPergunta.questaoPergunta.questao.tipoRespostaId == 1 && testeQuestaoPergunta.questaoPergunta.multiplasCorretas">
                                <br />
                                <ul class="list-group">
                                    <li class="list-group-item" v-for="questaoResposta in testeQuestaoPergunta.questaoPergunta.collectionQuestaoPerguntaResposta" v-bind:key="questaoResposta.questaoId">
                                        <label class="custom-control custom-checkbox">
                                            <!-- <input type="checkbox" v-model="testeQuestaoPergunta.respostas" :value="questaoResposta.resposta" class="custom-control-input"> -->
                                            <input type="checkbox" @change="testeQuestaoPergunta.resposta = testeQuestaoPergunta.respostas.join('|')" v-model="testeQuestaoPergunta.respostas" :value="questaoResposta.resposta" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description podeConterIMG" v-html="questaoResposta.resposta"></span>
                                        </label>
                                    </li>
                                </ul>
                            </div>

                            <!--pergunta do tipo preencha lacuna-->
                            <div v-if="testeQuestaoPergunta.questaoPergunta.questao.tipoRespostaId == 2">
                                <br />
                                <br />
                                <small>Preencha os campos abaixo de acordo com a lacuna.</small>
                                <br />
                                <div v-for="(questaoResposta, index2) in testeQuestaoPergunta.questaoPergunta.collectionQuestaoPerguntaResposta" v-bind:key="questaoResposta.questaoId">
                                    <div class="row mb-4">
                                        <div class="col-0"><strong style="line-height: 35px;">[{{ questaoResposta.ordem }}]</strong></div>
                                        <div class="col-10"><input type="text" name="questaoResposta.resposta" v-model="questaoResposta.resposta" @keyup="montaRespostaCompleteLacunas(testeQuestaoPergunta)" class="form-control"></div>
                                    </div>
                                </div>
                            </div>

                            <!--pergunta do tipo dissertativa-->
                            <div v-if="testeQuestaoPergunta.questaoPergunta.questao.tipoRespostaId == 3">
                                <textarea v-model="testeQuestaoPergunta.resposta" placeholder="Insira sua resposta." class="form-control" />
                            </div>

                            <div class="form-group">
                                <label class="custom-control custom-checkbox custom-control-inline">
                                    <input type="checkbox" v-model="testeQuestaoPergunta.revisarDepois" value="true" class="custom-control-input">
                                    <span class="custom-control-indicator"></span>
                                    <span class="custom-control-description">Revisar resposta depois.</span>
                                </label>
                            </div>
                            <hr />

                            <!--botoes se acoes-->
                            <ul class="pagination">
                                <li class="page-item" v-if="substep != 0">
                                    <button class="btn btn-sm btn-default" @click="voltarSubstep()"><i class="fa fa-arrow-left"></i> Questão anterior</button>
                                </li>
                                <li class="page-item" v-if="substep != totalsubstep">
                                    <button class="btn btn-sm btn-default" @click="openPausar()" v-b-tooltip title="Salvar teste e continuar posteriormente."><i class="fa fa-pause"></i> Pausar teste</button>
                                </li>
                                <li class="page-item" v-if="substep != totalsubstep">
                                    <button class="btn btn-sm btn-default" :disabled="!testeQuestaoPergunta.resposta && !testeQuestaoPergunta.revisarDepois" @click="proximoSubstep()">Próxima questão <i class="fa fa-arrow-right"></i></button>
                                </li>
                                <li class="page-item" v-if="botaoFinalizar">
                                    <button class="btn btn-sm btn-default" @click="irParaQuestao(totalsubstep)" v-b-tooltip title="Ir para o final">Finalizar <i class="fa fa-forward"></i></button>
                                </li>
                            </ul>

                        </div>

                        <!--ultimo passo conclusão do teste-->
                        <div class="card-body" v-if="substep == totalsubstep">
                            <div>
                                Revise suas respostas abaixo antes de finalizar. Caso necessário e haja tempo disponível, você poderá alterar suas respostas.
                            </div>
                            <hr />
                            <ul class="list-group">
                                <li class="list-group-item" v-bind:class="{ 'list-group-item-warning': testeQuestaoPergunta.revisarDepois }" v-for="(testeQuestaoPergunta, index) in teste.collectionTesteQuestaoPergunta" v-bind:key="testeQuestaoPergunta.questaoPerguntaId">
                                    <strong>{{ index + 1 }}) </strong> <span class="podeConterIMG" v-html="testeQuestaoPergunta.resposta || '--'" />
                                    <a class="float-right" v-if="testeQuestaoPergunta.revisarDepois">
                                        <em v-if="testeQuestaoPergunta.resposta" @click="irParaQuestao(index)">Revisar resposta</em>
                                        <em v-if="!testeQuestaoPergunta.resposta" @click="irParaQuestao(index)">Completar resposta</em>
                                    </a>
                                </li>
                            </ul>

                            <hr />

                            <ul class="pagination">
                                <li class="page-item" v-if="substep != 0">
                                    <button class="btn btn-sm btn-default" @click="voltarSubstep()"><i class="fa fa-arrow-left"></i> Questão anterior</button>
                                </li>
                                <li class="page-item" v-if="substep == totalsubstep">
                                    <button class="btn btn-sm btn-default" @click="finalizarTeste()" v-b-tooltip title="Clique para encerrar o teste e enviar suas respostas. Não será possível cancelar essa ação depois"><i class="fa fa-check"></i> Finalizar</button>
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>

            </div>

            <!--mensagem de tempo esgotado-->
            <div class="content-960" v-if="step == 3">
                <div class="wrapper-960 clearfix">
                    <div class="card">
                        <div class="card-body podeConterIMG">
                            <div v-if="temporestante == 0" class="text-center text-danger">
                                Seu tempo esgotou!
                                <br />
                            </div>
                            <div>
                                <div v-if="notaobtida >= teste.avaliacao.notaAprovacao" v-html="teste.avaliacao.mensagemAprovacao"></div>
                                <div v-if="notaobtida < teste.avaliacao.notaAprovacao" v-html="teste.avaliacao.mensagemReprovacao"></div>
                                <br />
                            </div>
                            <hr />
                            <button type="button" class="btn btn-sm btn-danger" v-b-tooltip title="Fechar e sair do teste" @click="closePagina()">
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!--mensagem de pausa de teste-->
            <div class="content-960" v-if="step == 4">
                <div class="wrapper-960 clearfix">
                    <div class="card">
                        <div class="card-body">
                            <div>
                                <strong>
                                    Seu teste foi pausado.
                                    <br />
                                    Peça para que um colaborador da escola CNA acesse o CNA Jobs para continuar seu teste quando necessário.
                                </strong>
                                <br />
                            </div>
                            <hr />
                            <button type="button" class="btn btn-sm btn-danger" v-b-tooltip title="Fechar e sair do teste" @click="closePagina()">
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </section>

        <!--confirmação de pausa de teste-->
        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" size="lg" centered v-model="dialogPausar" title="Confirmação">
            <p v-if="candidato">
                Você está prestes a pausar seu teste. Ele poderá ser retomado deste ponto dentro de um prazo até {{ candidato.diasValidadeCandidato }} dias.
                <br /> <br />
                Deseja continuar?
            </p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-default" @click="onClose()">
                    Não, desejo continuar o teste agora
                </button>
                <button class="btn btn-sm btn-danger" @click="pausarTeste()">
                    Sim, desejo pausar
                </button>
            </div>
        </b-modal>

    </main>

</template>
<script>

    import loading from '@/common/components/loading'
    import base from '@/common/base.js'
    import Cache from '@/common/cache'
    import Global from '@/common/global'
    import { Api } from '@/common/api'

    export default {
        name: 'testerealizar',
        mixins: [base],
        components: { loading },
        data() {
            return {
                variant: "warning",
                setintervaltimer: null,

                cpf: null,
                candidatoId: null,
                testeId: null,

                dialogPausar: false,
                botaoFinalizar: false,
                step: 0,
                substep: 0,
                totalsubstep: 0,
                notaobtida: 0,
                temporestante: 0,
                totalQuestoes:0,
                candidato: null,
                teste: null,
            }
        },
        computed: {
            progresso: function () {
                if (this.totalsubstep == 0) return 0;
                return this.substep / this.totalsubstep * 100;
            }
        },
        methods: {

            onClose: function () {
                this.dialogPausar = false;
            },

            openPausar: function (model) {
                this.dialogPausar = true;
                this.model = model;
            },

            buscarCandidato: function (cpf) {

                if (this.formValidate('testerealizar-form-cpf') == false)
                    return;

                if (!this.cpf || !this.candidatoId || !this.testeId)
                    return;

                new Api('candidato').get({
                    candidatoId: this.candidatoId,
                    testeId: this.testeId,
                    cpf: cpf.replace(/\D+/g, '')
                }).then(data => {
                    if (data.dataList && data.dataList.length > 0) {
                        this.candidato = data.dataList[0];
                        this.getTeste();
                    }
                    else
                        this.defaultErrorResult("Candidato ou teste não encontrado, verifique o CPF inserido.");
                }, err => {
                    this.defaultErrorResult(err);
                });
            },

            closePagina: function () {
                window.close();
            },

            passoAtual: function () {
                for (var i = 0; i < this.teste.collectionTesteQuestaoPergunta.length; i++) {
                    if (this.teste.collectionTesteQuestaoPergunta[i].resposta == null) {
                        return i;
                    }
                }
                return 0;
            },

            getTeste: function () {
                this.showLoading();
                new Api('teste/gettesterealizacao').get({
                    id: this.testeId,
                }).then(data => {
                    this.hideLoading();
                    if (data.data) {
                        console.log("teste", data.data);
                        this.teste = data.data;
                        this.totalQuestoes = data.data.collectionTesteQuestaoPergunta.length+1;
                        this.temporestante = this.teste.tempoRestante;
                        this.step = 1;
                        this.substep = this.passoAtual();
                        this.totalsubstep = this.teste.collectionTesteQuestaoPergunta.length;
                        this.preparaElementosPergunta();
                    }
                }, err => {
                    this.defaultErrorResult(err);
                });
            },            

            montaRespostaCompleteLacunas: function (testeQuestaoPergunta) {
                let _respostas = []
                testeQuestaoPergunta.questaoPergunta.collectionQuestaoPerguntaResposta.forEach(_ => {
                    if (_.resposta) _respostas.push(_.resposta);
                });
                testeQuestaoPergunta.resposta = _respostas.join([' | '])
            },

            formValidate: function (form) {
                var $form = this.$refs[form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            irParaQuestao: function (index) {
                this.substep = index;
            },

            iniciarTeste() {
                new Api('teste').put({
                    testeId: this.testeId,
                    attributeBehavior: "IniciarContagemTeste",
                }).then(() => {
                    this.step = 2;
                    this.limpaSetintervaltimer();
                    this.setintervaltimer = setInterval(() => {
                        this.adicionarTempoUtilizado();
                    }, 60000);
                }, err => {
                    this.defaultErrorResult(err);
                    this.step = 0;
                });
            },

            limpaSetintervaltimer() {
                if (this.setintervaltimer)
                    clearInterval(this.setintervaltimer);
            },

            adicionarTempoUtilizado() {
                new Api('teste/adicionartempoutilizado').put({
                    testeId: this.testeId,
                }).then(result => {
                    this.temporestante = result.data.tempoRestante;
                    if (this.temporestante == 0)
                        this.finalizarTeste();
                    else
                        this.salvarTeste();
                });
            },

            finalizarTeste() {
                let _teste = this.preparaModelSave(this.teste, { attributeBehavior: "FinalizarTeste", ehLivreRedeCna: true });
                this.showLoading();
                new Api('teste').put(_teste).then(data => {
                    this.hideLoading();
                    this.notaobtida = data.data.nota;
                    this.step = 3;
                }, err => {
                    this.defaultErrorResult(err);
                    this.step = 2;
                });
            },

            pausarTeste() {
                this.dialogPausar = false;
                let _teste = this.preparaModelSave(this.teste, { attributeBehavior: "PausarTeste" });
                console.log(this.teste,"teste preparar teste...");
                this.showLoading();
                new Api('teste').put(_teste).then(() => {
                    this.defaultSuccessResult("Teste salvo com sucesso.");
                    this.step = 4;
                }, err => {
                    this.defaultErrorResult(err);
                });
            },

            salvarTeste() {
                let _teste = this.preparaModelSave(this.teste, { attributeBehavior: "SalvarTeste" });
                new Api('teste').put(_teste).then(() => {}, err => {});
            },

            preparaModelSave(teste, newteste) {

                let _teste = JSON.parse(JSON.stringify(teste));

                _teste = Object.assign(_teste, newteste);

                _teste.collectionTesteQuestaoPergunta = _teste.collectionTesteQuestaoPergunta.map(item => {
                    item.questaoPergunta.pergunta = null;
                    item.questaoPergunta.questao = null;
                    return item;
                });

                return _teste
            },

            preparaElementosPergunta: function () {
                setTimeout(() => {
                    var _elements = document.querySelectorAll("audio, video");
                    for (var i = 0; i < _elements.length; i++) {
                        var _el = _elements[i];
                        _el.setAttribute("controlsList", "nodownload");
                    }
                }, 500)
            },

            proximoSubstep() {
                this.substep++;
                if (this.substep == this.totalsubstep) this.botaoFinalizar = true;
                this.salvarTeste();
                this.preparaElementosPergunta();
            },

            voltarSubstep() {
                this.substep--;
            },
            
            addRespostaMultipla(questaoResposta) {
                // console.log(questaoResposta)
                let index = this.teste.collectionTesteQuestaoPergunta.findIndex(_ => _.questaoPerguntaId == questaoResposta.questaoPerguntaId);
                // for (let resp in this.$refs['multiplasRespostas'])
                // {
                //     if (resp.checked) this.teste.collectionTesteQuestaoPergunta[index].resposta = resp.value
                // }
            }

        },

        mounted() {

            let _accessToken = this.$route.query.accesstoken;
            if (_accessToken) Cache.add(Global.ACCESS_TOKEN, _accessToken);

            this.candidatoId = +this.$route.params.candidatoId;
            this.testeId = +this.$route.params.testeId;

            let _cpf = this.$route.params.cpf;
            if (_cpf) this.cpf = _cpf;

            this.configNotification();
            this.limpaSetintervaltimer();

            //window.addEventListener("beforeunload", (e) => {
            //    var confirmationMessage = "Ao sair desta página você perderá todo o seu processo.";
            //    e.returnValue = false;
            //    return confirmationMessage;
            //});
        },

        beforeDestroy() {
            this.$eventHub.$off('show-notification');
            this.limpaSetintervaltimer();
        },

    };
</script>